import type { FunctionComponent } from "react";
import { SocialsSliderMenuPartial } from "../../../../partials/admin/menus/socials/social-slider-menu.admin.partials";

export const SocialsSliderMenuAdminScreen: FunctionComponent = () => {
	return <SocialsSliderMenuPartial />;
};
